import React, { useEffect, useState } from 'react';

import { asTemplate } from 'transformers/templates';
import { SortingPreferences, sortBy } from 'types/Sorting';
import Template from 'types/Template';
import { useJsonboxAxios } from 'utils/jsonbox';
import {
  getTemplatesSorting as readTemplatesSorting,
  setTemplatesSorting as saveTemplatesSorting,
} from 'utils/storage';
import { useCollection } from 'utils/useCollection';
import withCollection from 'utils/withCollection';
import Templates from './Templates';

const TemplatesController: React.FC = () => {
  const [sortingPreferences, setSortingPreferences] = useState<SortingPreferences | null>(null);

  const { collection } = useCollection();

  const [{ data, loading }, executeGet] = useJsonboxAxios({ method: 'GET' }, { manual: true });
  const [{ loading: deleteLoading }, executeDelete] = useJsonboxAxios({ method: 'DELETE' }, { manual: true });

  const handleOnChangeSorting = (sortingPreferences: SortingPreferences) => {
    setSortingPreferences(sortingPreferences);
    saveTemplatesSorting(sortingPreferences as unknown as Record<string, unknown>);
  };

  useEffect(() => {
    const sortingPreferences = readTemplatesSorting() as unknown as SortingPreferences;
    if (sortingPreferences) {
      setSortingPreferences(sortingPreferences);
    } else {
      setSortingPreferences({
        field: 'template_name',
        direction: 'asc',
      });
    }
  }, []);

  useEffect(() => {
    if (!collection) return;

    executeGet({
      url: `/${collection.id}?limit=1000`,
    });
  }, [collection, executeGet]);

  const handleOnDeleteTemplate = async (template: Template) => {
    if (!collection) return;

    await executeDelete({
      url: `/${collection.id}/${template.id}`,
    });

    return executeGet({
      url: `/${collection.id}`,
    });
  };

  if (!collection) {
    return null;
  }

  if (!sortingPreferences) {
    return null;
  }

  const templates = data?.map(asTemplate) || [];
  const sortedTemplates = sortBy(templates, sortingPreferences);

  return (
    <Templates
      loadingTemplates={loading || deleteLoading}
      templates={sortedTemplates}
      collection={collection}
      sortingPreferences={sortingPreferences}
      onChangeSorting={handleOnChangeSorting}
      onDelete={handleOnDeleteTemplate}
    />
  );
};

export default withCollection(TemplatesController);
